
import React from "react"
// import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const CheckIE = ({children, ver}) => {
	const ie = React.useRef()
	React.useEffect(()=>{
		ie.current = require('ie-version')
	},[ie.current])
	return (
		<Helmet>
			{ ie.current && ver === ie.current.version ?
				children : null
			}
		</Helmet>
	)
}

function SEO({
	lang,
	title,
	description,
	meta,
	image,
	pathname,
	keywords,
	isArticle,
}){
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						local
						title
						desc
						site_url
						site_name
						site_publisher
						image
						sns_twitter_id
						google_site_verification
						keywords
					}
				}
			}
		`
	)

	const d = site.siteMetadata
	const seo = {
		title: title ? `${title} | ${d.title}` : `${d.title}`,
		description: description || `${d.desc}`,
		image: `${d.site_url}${ image || d.image}`,
		url: `${d.site_url}${ pathname || "/"}`,
		twitterId: d.sns_twitter_id,
		googleSiteVerification: d.google_site_verification,
		keywords: keywords || `${d.keywords}`,
		name: d.site_name,
		publisher: d.site_publisher,
	}

	const isProd = process.env.GATSBY_PROD

	return (
			<React.Fragment>
				<Helmet>
					<title>{seo.title}</title>
					<meta name="copyright" content="Copyright (C) FUJITSU"/>
					<meta name="keywords" content="富士通, スマートフォン, スマホ, タブレット, 携帯電話, 製品特長, FMWORLD, arrows 5G F-51A, アローズ, 人気, ドコモ, 最新, 5G, Adobe, Photoshop Express, スゴ写, 盛れる, 写真, カメラ, フィルター, 文字入れ, コラージュ, フォトエディタ"/>
					<meta name="description" content="富士通コネクテッドテクノロジーズ製スマートフォン、arrows 5G F-51A × Adobe Photoshop Expressの紹介ページです。いいね！な光景を目の前にしながら、伝えたい気持ちを写真にのせる、 arrows 5Gなら、撮影から編集までが流れるような体験になります。"/>
					<meta property="og:title" content="#スゴ写「arrows 5G × Adobe Photoshop Express」の編集カメラがすごい"/>
					<meta property="og:url" content="https://www.fmworld.net/product/phone/f-51a/arrows-adobe/"/>
					<meta property="og:description" content="いいね！な光景を目の前にしながら、伝えたい気持ちを写真にのせる、 arrows 5Gなら、撮影から編集までが流れるような体験になります。"/>

					<meta property="og:image" content="http://www.fmworld.net/product/phone/f-41a/images/1/f-41a-snsthumb.jpg"/>

					<meta name="format-detection" content="telephone=no"/>
					<meta name="viewport" content='width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no'/>

					<script>{`
						(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','GTM-NC3KPSF');
					`}</script>

				</Helmet>
				<CheckIE ver={8}>
					<script src="/product/phone/common/rnw2015/js/html5shiv-printshiv.js" charset="UTF-8"></script>
					<script src="/product/phone/common/rnw2015/js/selectivizr-min.js" charset="UTF-8"></script>
				</CheckIE>
				<Helmet>
					<script src="/product/phone/common/rnw2015/js/jquery-1.11.2.min.js" charset="UTF-8"></script>
					<script src="/product/phone/common/rnw2015/js/uaInfo.js" charset="UTF-8"></script>
					<link rel="stylesheet" href="/product/phone/common/rnw2015win/css/base.css"/>
					<link rel="stylesheet" href="/product/phone/common/rnw2015win/css/pc_base.css" media="screen and (min-width: 751px)"/>
					<link rel="stylesheet" href="/product/phone/common/rnw2015win/css/sp_base.css" media="screen and (max-width: 750px)"/>
					<link rel="stylesheet" href="/product/phone/common/rnw2016sum/css/sp_base.css" media="screen and (max-width: 750px)"/>
					<link rel="stylesheet" href="/product/phone/common/rnw2015win/css/pc_base.css" media="print"/>
					<link rel="stylesheet" href="/product/phone/common/product_style/pc_product.css" media="screen and (min-width: 751px)"/>
					<link rel="stylesheet" href="/product/phone/common/product_style/sp_product.css" media="screen and (max-width: 750px)"/>
					<link rel="stylesheet" href="/product/phone/common/product_style/pc_product.css" media="print"/>
					<link rel="stylesheet" href="/product/phone/f-51a/css/pc_product.css" media="screen and (min-width: 751px)"/>
					<link rel="stylesheet" href="/product/phone/f-51a/css/sp_product.css" media="screen and (max-width: 750px)"/>
					<link rel="stylesheet" href="/product/phone/f-51a/css/pc_product.css" media="print"/>
					<link rel="stylesheet" href="/product/phone/f-41a/css/pc_product.css" media="screen and (min-width: 751px)"/>
					<link rel="stylesheet" href="/product/phone/f-41a/css/sp_product.css" media="screen and (max-width: 750px)"/>
					<link rel="stylesheet" href="/product/phone/f-41a/css/pc_product.css" media="print"/>
					<link rel="stylesheet" href="/product/phone/common/gnavi/css/arrows.css" media="all"/>
				</Helmet>
				<CheckIE ver={8}>
					<link rel="stylesheet" href="/product/phone/common/rnw2015win/css/pc_base.css" />
					<link rel="stylesheet" href="/product/phone/common/rnw2015win/css/ie8_base.css" />
					<link rel="stylesheet" href="/product/phone/common/product_style/pc_product.css" />
				</CheckIE>
				<Helmet>
					<script src="/product/phone/common/rnw2015/js/jquery.easing.1.3.js" charset="UTF-8"></script>
					<script src="/product/phone/common/rnw2015/js/jquery.flatheights.js" charset="UTF-8"></script>
				</Helmet>
				<CheckIE ver={8}>
					<script src="/product/phone/common/rnw2015/js/jquery.belatedPNG.min.js" charset="UTF-8"></script>
					<script src="/product/phone/common/rnw2015/js/PIE.js" charset="UTF-8"></script>
				</CheckIE>
				<Helmet>
					<script src="/product/phone/common/gnavi/js/common.js" charset="UTF-8"></script>
					<script src="/product/phone/common/rnw2015/js/ua-decision.js" charset="UTF-8"></script>
					<script src="/product/phone/f-51a/js/product_hs.js" charset="UTF-8"></script>
					<script type="text/javascript" src="/images/common/js/gacode.js"></script>
				</Helmet>
				
			</React.Fragment>
	)
}

export default SEO
